export default "__VITE_ASSET__CkToe915__"